var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"reports-modal-preview"},_vm._l((4),function(i){return _c('img',{key:i,staticClass:"reports-modal-preview__image",attrs:{"src":require("@/assets/images/reports/report-preview.png"),"alt":`preview ${i}`}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }